import axios from "axios";
import { BASE_URL } from "../../../Helper/Helper";

const TaskState = {
  addTask: async (requestOptions) => {
    // FETCH API CALL For all notes
    const response = await axios.post(
      `${BASE_URL}/api/v2/admin/create-task`,
      requestOptions,
      {
        headers: {
          token: localStorage.getItem("token"),
        },
      }
    );

    // console.log("res", response);
    let datas = response.data;
    return datas;
  },

  getTask: async (params) => {
    // FETCH API CALL For all notes
    const response = await axios.get(`${BASE_URL}/api/v2/admin/get-all-task`, {
      params,
      headers: {
        token: localStorage.getItem("token"),
      },
    });

    let datas = response.data;
    return datas;
  },

  updateTask: async (id, requestOptions) => {
    // FETCH API CALL For all notes
    const response = await axios.put(
      `${BASE_URL}/api/v2/admin/update-task/${id}`,
      requestOptions
    );

    let datas = response.data;
    return datas;
  },

  updateTaskStatus: async (id, requestOptions) => {
    // FETCH API CALL For all notes
    const response = await axios.post(
      `${BASE_URL}/api/v2/admin/task-status/${id}`,
      requestOptions,
      {
        headers: {
          token: localStorage.getItem("token"),
        },
      }
    );

    let datas = response.data;
    // console.log("datas", datas);
    return datas;
  },

  deleteTask: async (id) => {
    // FETCH API CALL For all notes
    const response = await axios.delete(
      `${BASE_URL}/api/v2/admin/delete-task/${id}`,
      {
        headers: {
          token: localStorage.getItem("token"),
        },
      }
    );

    let datas = response.data;
    return datas;
  },
};

export default TaskState;
